Vendd.Scripts.load(function () {

    var $forms = $('.form-pop-up');

    if ($forms.length < 1) return;

    $forms.each(function (index) {
        var $form = $(this);
        var form = $form.get(0);
        
        // reCAPTCHA
        var reCaptchaCode;
        var captchaId = "popUpFormCaptcha-" + index;
        var captchaWidgetId;
        var $captchaElement = $form.find("#" + captchaId);
        var $captchaContainer = $form.find('.recaptcha-container');
        var captchaEnabled = $captchaElement.length > 0 ? true : false;

        var formData = {
            "interestType": "",
            "branches": "",
            "vehicleCode": "",
            "campaignCode": "",
            "campaignHash": "",
            "firstName": "",
            "lastName": "",
            "email": "",
            "phone": "",
            "message": "",
            "bySMS": false,
            "byEmail": false,
            "byPhone": false,
            "byPost": false
        };

        $submitButton = $('.js-submit-button', $form);

        form.initPopUp = function () {
            $.fancybox.open($form,
                {
                    touch: false,
                    infobar: false,
                    beforeLoad: function () {
                        form.reset();
                        form.getBranches();
                    },
                    afterClose: function () {
                        //Reset the form
                        form.reset();
                    }
                }
            );
        };

        form.initRecaptcha = function () {

            if (!captchaEnabled)
                return;

            var sitekey = $captchaElement.data("sitekey");
            if (sitekey) {
                captchaEnabled = true;
                captchaWidgetId = grecaptcha.render(captchaId, {
                    'sitekey': sitekey,
                    'callback': form.recaptchaCallback
                });
            }
        };

        form.recaptchaCallback = function () {
            form.validateRecaptcha();
        };

        form.resetRecaptcha = function () {
            // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
            // If a verify attempt has been made with a particular token, it cannot be used again. 
            // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
            if (captchaEnabled)
                grecaptcha.reset(captchaWidgetId);
        };

        form.removeRecaptcha = function () {
            $captchaElement.remove();
        };

        form.validateRecaptcha = function () {
            if (!captchaEnabled)
                return true;

            reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

            var res = false;

            if (reCaptchaCode) {
                $captchaContainer.find('.recaptcha-required').removeClass('error');
                res = true;
            }
            else {
                $captchaContainer.find('.recaptcha-required').addClass('error');
            }

            return res;
        };

        form.loading = function (loading) {
            if (loading) {
                $('form', $form).addClass('x-loading');
            } else {
                $('form', $form).removeClass('x-loading');
            }
        };

        form.getBranches = function () {
            form.loading(true);

            var $branchCont = $('.branch-wrapper', $form);
              
            if ($branchCont.length > 0) {
                $.ajax({
                    url: "/services/api/OneDealerInquiry/GetMakes",
                    type: 'POST',
                    success: function (data, status, xhr) {
                        if (data.success) {
                            var html = Vendd.Handlebars.parse("branchOptions_A", data.data);                           
                            $('select[name="branches"]', $form).append(html);
                        } else {
                            //$('.js-content', $form).hide();
                            $('.js-form-error', $form).text(data.message).show();
                            form.resetRecaptcha();
                        }

                        form.loading(false);
                    },
                    error: function (result, status, xhr) {
                        form.loading(false);
                        //$('.js-content', $form).hide();
                        $('.js-form-error', $form).text(result.message).show();
                        form.resetRecaptcha();
                    }
                });
            }
        };

        form.onSuccess = function () {
            if (!$form.hasClass('x-loading'))
                return;

            form.loading(false);

            $('.js-form-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).css({
                'display': 'flex'
            });

            if ($(window).width() < 480) {
                var toScroll = $('.form-title-container', $form).offset().top - 20;
                $('.fancybox-inner').animate({
                    scrollTop: toScroll
                }, 100, 'swing');
            }
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({ 'event': 'formSubmitSuccess', 'formType': 'requestQuote', 'formName': $('.full-screen-popup[data-form-btn="#' + $form.data('type') + '"]').data('form-name'), 'site': LhApp.Url.Page.Home });
            }

            var querystring = '?form=success';
            window.history.pushState({}, '', querystring);
            form.reset();
        };

        form.onFailure = function (envelope) {

            form.loading(false);
            var $errorElem = $('.js-form-error', $form);

            $errorElem.show();

            if ($(window).width() < 480) {
                var toScroll = $errorElem.offset().top - 20;
                $('.fancybox-inner').animate({
                    scrollTop: toScroll
                }, 100, 'swing');
            }
        };

        form.submit = function () {
            form.loading(true);

            $('input, textarea:not([name="g-recaptcha-response"]), select', $form).each(function () {
                if ($(this).attr('name') === 'email') {
                    formData[$(this).attr('name')] = $(this).val().trim();
                } else {
                    formData[$(this).attr('name')] = $(this).val();
                }
            });

            formData.byEmail = $('input[name="byEmail"]', $form)[0].checked;
            formData.byPhone = $('input[name="byPhone"]', $form)[0].checked;
            formData.bySMS = $('input[name="bySMS"]', $form)[0].checked;
            formData.byPost = $('input[name="byPost"]', $form)[0].checked;

            formData.interestType = $form.attr('data-type');
            formData.vehicleCode = $form.attr('data-vehicle-code');
            formData.campaignCode = $form.attr('data-campaign-code');

            if ($form.attr('data-campaign-hash') === "true")
                formData.campaignHash = getQueryStringValueByName('vdlt');

            $.ajax({
                url: "/services/api/OneDealerInquiry/CreateInquiryInterestByCase",
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    InterestType: formData.interestType,
                    BranchCode: formData.branches,
                    VehicleCode: formData.vehicleCode,
                    CampaignCode: formData.campaignCode,
                    ReferralCampaignHash: formData.campaignHash,
                    FirstName: formData.firstName,
                    LastName: formData.lastName,
                    Email: formData.email,
                    Phone1: formData.phone,
                    Message: formData.message,
                    ALLOWCONTACTBYSMS: formData.bySMS,
                    ALLOWCONTACTBYPHONE: formData.byPhone,
                    ALLOWCONTACTBYEMAIL: formData.byEmail,
                    ALLOWCONTACTBYPOST: formData.byPost
                }),
                success: function (data, status, xhr) {

                    if (data.success) {
                        form.reset();
                        form.resetRecaptcha();
                        $('.js-content', $form).hide();
                        $('.js-success', $form).show();
                    } else {
                        // $('.js-content', $form).hide();
                        $('.js-form-error', $form).text(data.message).show();
                        form.resetRecaptcha();
                    }

                    form.loading(false);
                },
                error: function (result, status, xhr) {

                    form.loading(false);
                    //$('.js-content', $form).hide();
                    $('.js-form-error', $form).text(result.message).show();
                    form.resetRecaptcha();
                }
            });
        };

        form.reset = function () {

            $('.js-form-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-success', $form).hide();
            $('.js-content', $form).show();

            $('input[name="firstName"]', $form).val("");
            $('input[name="lastName"]', $form).val("");
            $('input[name="phone"]', $form).val("");
            $('input[name="email"]', $form).val("");

            $('select[name="branches"]', $form).val("");
            $('select[name="branches"]', $form).find('option').not(':first').remove();

            $('select[name="carModel"]', $form).val("");
            $('select[name="topic"]', $form).val("");
           
            $('textarea[name="message"]', $form).val("");
            $('.recaptcha-container .validator', $form).removeClass('error');
            $('input[name="byEmail"]', $form).prop('checked', false);
            $('input[name="bySMS"]', $form).prop('checked', false);
            $('input[name="byPhone"]', $form).prop('checked', false);
            $('input[name="byPost"]', $form).prop('checked', false);

            formData = {
                "interestType": "",
                "branches": "",
                "vehicleCode": "",
                "campaignCode": "",
                "campaignHash": "",
                "firstName": "",
                "lastName": "",
                "email": "",
                "phone": "",
                "message": "",
                "bySMS": false,
                "byEmail": false,
                "byPhone": false,
                "byPost": false
            };
            form.resetRecaptcha();
            rf.reset();
        };

        //init validation options
        var validationOptions = {};

        //add required validations
        $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
            var inputName = $(el).attr('name');
            validationOptions[inputName] = { required: inputName + '-required' };
        });

        $form.validationEngine(validationOptions);
        var rf = $form.data('validationEngine');

        $form.on('click', '.js-submit-button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var val1 = rf.validate();
            var val2 = form.validateRecaptcha();

            if (val1 && val2) {
                form.submit();
            } else {
                //form.handleErrors();
            }
        });

        $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();

                $submitButton.click();

                return;
            };

            form.setField($(this));
        });

        $form.on('change', 'select[name]', function (e) {
            form.setField($(this));
        });

        form.setField = function (field) {
            var fieldName = field.attr('name');
            rf.validate(fieldName);
        };

        Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

        if ($form.data('layout') === 'inline')
            form.getBranches();
    });

});